const formLayout = {
    labelCol: {
        span: 3
    },
    controllerCol: {
        span: 9
    }
};

export default formLayout;
